import React, { useEffect, useState } from 'react'
import "./AddressBox.css"
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { useSelector } from 'react-redux';
import { Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap';
import AlertContainer from '../Alert/Alert';

function AddressBox({ defaultState, item, getAddress }) {
  const location = useLocation();
  const userinfo = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [name, setName] = useState(item && item.title)
  const [phone, setPhone] = useState(item && item.phone?.phone)
  const [city, setCity] = useState(item && item.city?.id)
  const [block, setBlock] = useState(item && item.block)
  const [street, setStreet] = useState(item && item.street)
  const [region, setRegion] = useState(item && item.region)
  const [cities, setCities] = useState([])
  const [house_number, setHouse_number] = useState(item && item.house_number)
  const [longitude, setLongitude] = useState(item && item.longitude)
  const [defulatLoading, setDefulatLoading] = useState(false)
  const [address, setAddress] = useState(item && item.notes)
  const [latitude, setLatitude] = useState(item && item.latitude)
  const [showModal, setShowModal] = useState(false);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  useEffect(() => {
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/smile/api/countries/1/cities`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })

        .then(async (res) => {
          setCities(res.data.data.data);

          // setShow(true)

          //                     setAddress(res.data)

        })
        .catch((error) => {
          setShow(true)



        });

    }
    getAllApis()
  }, [])




  const sendData = async (e) => {
    e.preventDefault();
    setLoading(true)
    const data = {
      "title": name,

      "city_id": city,

      latitude:
        30.123456,

      longitude:
        31.123456,

      block,
      region,

      street,

      house_number,

      address,

      phone,


    };
    await axios
      .put(`https://nanosoft.technology/smile/api/client/addresses/${item.id}`, data,
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.access_token}`
          }
        })
      .then(async (res) => {
        setAlert('Address added successfully')
        setModalShow(false)
        setLoading(false)
        await getAddress()
        setShow(true)
        setMsg(currentLocal.home.addsuccessMessage)
        setSeverity("success")
        setTimeout(() => {
          setShow(false);

          setMsg("")

        }, 2000);
      })

      .catch((error) => {

        setAlert(error.response.data.error)
        setLoading(false)

        // Toast.show("Email or password is not correct!", {
        //   type: "danger",
        // });
      });
  }
  return (
    <div
      className='adress_box_container'
    >
      {show &&
        <AlertContainer
          msg={msg}
          severity={severity}
        />

      }
      <Modal
        show={modalShow}
        style={{
          zIndex:"10000000000000000000"
        }}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='edit_model'
      >
        <Modal.Header closeButton className='py-1 border-bottom-0'>

        </Modal.Header>
        <form onSubmit={sendData}>

          <Modal.Body>
            <Container>
              <Row>




                <Col md={12}>
                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.namePlaceholder} </label>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </Col>
                <Col md={12}>


                  <label className='mb-1'>{currentLocal.home.city} </label>

                  <Form.Select aria-label="Product In Stock"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}>
                    <option>{currentLocal.home.city}</option>
                    {cities && cities.map((item, index) => {

                      return (
                        <option value={item.id} key={index}>{item.name}</option>

                      )
                    })}
                  </Form.Select>
                </Col>
                <Col md={6}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.region}  </label>
                    <input
                      placeholder={currentLocal.home.region}
                      value={region}
                      onChange={(e) => setRegion(e.target.value)}

                    />
                  </div>
                </Col>
                <Col md={6}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.street}  </label>
                    <input
                      placeholder={currentLocal.home.street}
                      value={street}
                      onChange={(e) => setStreet(e.target.value)}

                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.buildingNumber}  </label>
                    <input
                      placeholder={currentLocal.home.buildingNumber}
                      value={block}
                      onChange={(e) => setBlock(e.target.value)}

                    />
                  </div>
                </Col>

                <Col md={6}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.house_number} </label>
                    <input
                      placeholder={currentLocal.home.house_number}
                      value={house_number}
                      onChange={(e) => setHouse_number(e.target.value)}

                    />
                  </div>
                </Col>
                <Col md={12}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.phone} </label>
                    <input
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}

                    />
                  </div>
                </Col>
                <Col md={12}>
                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.Detailedaddress} </label>

                    <input
                      placeholder={currentLocal.home.Detailedaddress}

                      value={address}
                      onChange={(e) => setAddress(e.target.value)}

                    />
                  </div>
                </Col>

              </Row>
            </Container>








          </Modal.Body>
        </form>

        <Modal.Footer className='justify-content-between'>

          {/* <button type="submit" className=" edit_btn " onClick={sendData}>
            
            
            {currentLocal.home.Save}</button> */}
          <button className={loading ? 'disaactive_login_btn d-flex justify-content-center align-items-center' : 'login_btn d-flex justify-content-center align-items-center'} type='submit' disabled={loading && true} onClick={sendData}>
            {loading &&
              <Spinner animation="border" role="status" className='mx-3' size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            }
            <p className='mb-0'>
              {currentLocal.home.Save}
            </p>
          </button>

        </Modal.Footer>
      </Modal>
      <div className='fw-bold'>
        {item && item.title}

      </div>
      <div className='fw-bold'>
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="mr-1 text-gray-600" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: "-2px" }}><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 5.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6zm-.5 6.5v3H11v-3h-1v3h-.5v-3h-1v3c0 .83.67 1.5 1.5 1.5v4h1v-4c.83 0 1.5-.67 1.5-1.5v-3h-1zm1.5 2v3h1V18h1V9.5c-1.1 0-2 .9-2 2z"></path></svg>

        {currentLocal.home.city} :{item && item.city?.name} , {currentLocal.home.region} :  {item && item.region}, {currentLocal.home.street} :  {item && item.street} ,{currentLocal.home.buildingNumber}:  {item && item.block} ,{currentLocal.home.house_number} :  {item && item.house_number}
      </div>
      <p>{currentLocal.home.Detailedaddress}: {item && item.notes}</p>
      {/* <p>Notes: {item && item?.notes}</p> */}


        <div className='d-flex justify-content-between'>
          {item && item.isDefault ?
            <p className='default'>{currentLocal.home.Default}</p>
            :
            <p></p>
          }
          <div className='d-flex actions'>
    
      {!['checkout', 'order'].includes(location.pathname.substring(1)) &&

       <p style={{ cursor: "pointer" }} onClick={handleShow}>{currentLocal.home.delete}</p> 
      }
        
            <Modal show={showModal} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter"
              centered>

              <Modal.Body>
                <div className="modal-body py-1 text-center">
                  {currentLocal.home.areyousureyouwantdelet}

                </div>
                <div className="modal-footer border-top-0 d-flex justify-content-center">



                  <button
                    type="button"
                    className="btn bg-secondary text-white fw-bold px-4"
                    onClick={handleClose}
                  >{currentLocal.home.close}</button>
                  <button
                    type="button"
                    className="btn bg-danger text-white fw-bold px-4 d-flex justify-content-center"
                    onClick={async () => {
setLoading(true)
                      await axios
                        .delete(`https://nanosoft.technology/smile/api/client/addresses/${item.id}`,

                          {
                            headers: {
                              Authorization: `Bearer ${userinfo.auth.access_token}`
                            }
                          })

                        .then(async (res) => {
                          await getAddress()
                          setLoading(false)

                          setShow(true)
                                                    handleClose();

                          setSeverity("success")
                          setMsg(currentLocal.home.deletesuccessMessage)
                          setTimeout(() => {
                            setShow(false)
                            setSeverity("")
                            setMsg("")

                          }, 1500);
                        })
                        .catch((error) => {
                          setShow(true)
                          setLoading(false)



                        });

                    }}
                  >

                    {loading&&
      <Spinner animation="border" role="status" className='mx-3' size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
}
                    <p className='mb-0'>{currentLocal.home.delete}</p>
                  </button>



                </div>

              </Modal.Body>

            </Modal>
            {/* <div className="modal fade" id="addressModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header border-bottom-0 d-flex justify-content-end py-1">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className='fs-3'>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body py-1 text-center">
                    Are You Sure You Want to delete this address?

                  </div>


                </div>
              </div>
            </div> */}
            
            <div className='edit_container' onClick={() => setModalShow(true)}>{currentLocal.home.edit}</div>
            
            </div>

        </div>
    </div>
  )
}

export default AddressBox